export default __webpack_public_path__ + "static/media/step6-icon.d5d078e7.svg";